import { Component, OnInit,AfterViewInit } from '@angular/core';
import { ActionSheetController } from '@ionic/angular';
import { GridBaseCase } from '../grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { NativeService } from '../../../../service/native.service';
import { BaseCase } from '../../../basecase';
declare var app;

@Component({
  selector: 'app-sfa-list-icebox',
  templateUrl: './sfa-list-icebox.component.html',
  styleUrls: ['./sfa-list-icebox.component.scss']
})
export class SfaListIceboxComponent extends GridBaseCase {

  constructor( 
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public actionSheetController: ActionSheetController,
    public native:NativeService) { super(); }

 
  LoadData() {
    let that = this;
    that.loading = false;
    that.apiObj['status'] = false;
    that.apiObj['msg'] = '';
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 10;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if (!that.com.GetAccount.IsAdmin) {
      // console.log(that.month);
      // if (!that.searchDate) {
      //   let nowyear:any = that.com.getNow.split('-')[0];
      //   let nowmonth:any = that.com.getNow.split('-')[1];
      //   let startDate = nowyear + "-" + nowmonth + "-" + "01" + " 00:00:00";
      //   let day = new Date(nowyear, nowmonth, 0);
      //   let endDate = nowyear + "-" + nowmonth + "-" + day.getDate() + " 23:59:59";
      //   that.searchDate = that.com.BetweenDate(startDate, endDate);
      // }
      // //请假列表
      // if (that.searchDate) {
      //   body.RequestBody = JSON.stringify({ "a_FK_SystemUser_ID":that.com.GetAccount.Id,"a_ModifyTime": that.searchDate });
      // }else{
      //   body.RequestBody = JSON.stringify({"a_FK_SystemUser_ID":that.com.GetAccount.Id,"a_ModifyTime": that.searchDate });
      // }
      // if(that.baseService.storeSearch.name){

      //   body.RequestBody= JSON.stringify({"store_FK_SystemUser_ID":that.com.GetAccount.Id,"a_name":that.baseService.storeSearch.name});
      // }else{
      //   body.RequestBody= JSON.stringify({"store_FK_SystemUser_ID":that.com.GetAccount.Id});
      // }
      // body.RequestBody= JSON.stringify({"store_FK_SystemUser_ID":that.com.GetAccount.Id});
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      that.baseService.arrayData = [];
      setTimeout(function () {
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      });
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
          });
          that.baseService.arrayData.push(objfield);
          // console.log(that.element.selectItemList.selectItem);
          console.log( that.baseService.arrayData);
        });
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }
  EventLink(ev: any, parms: any) {
    let evs = ev.url || '';
    if (evs.trim() && parms) {
      if (evs.indexOf("http") > 0) {
      } else {
        this.com.setHistoryUrl();
        // this.router.navigateByUrl(evs + "/" + parms.id);
        this.com.Go(evs + "/" + parms.id);
      }
    }

  }
}
